import {SHIPMENT_FLOW_TRIGGER_IDS} from "../../../consts/SHIPMENT_FLOW_TRIGGER_IDS";

export const isNotificationFormValid = (formValues: any, flowTriggerId?: number) => {
    const errors = [];
    const isImmediateTriggerDelayAllowed = flowTriggerId && SHIPMENT_FLOW_TRIGGER_IDS.includes(flowTriggerId);
    if(formValues.title.length < 3) {
        errors.push('Please type a meaningful title');
    }
    if(formValues.content.length < 10) {
        errors.push('The content of your message is too short');
    }
    if(formValues.content.length > 900) {
        errors.push('The content of your message is too long');
    }
    if((!isImmediateTriggerDelayAllowed && formValues.triggerDelay < 120) || formValues.triggerDelay > 60*60*24*62) {
        errors.push('Trigger delay should be between 3 minutes to 2 months');
    }
    if(formValues.distributionPercent < 1 || formValues.distributionPercent > 100) {
        errors.push('Distribution should be between 1 to 100 percent');
    }
    return errors;
}